import { dayjs } from '@ui';

/**
 * Checks if a given date of birth represents a minor (under 18 years old)
 * @param dob - Date of birth (can be string, Date, or dayjs object)
 * @param referenceDate - Optional reference date (defaults to current date)
 * @returns true if the person is under 18 years old, false otherwise
 */
export const isMinor = (
  dob: string | Date | dayjs.Dayjs | null | undefined,
  referenceDate?: string | Date | dayjs.Dayjs
): boolean => {
  if (!dob) return false;

  const dobDate = dayjs(dob);
  if (!dobDate.isValid()) return false;

  const refDate = referenceDate ? dayjs(referenceDate) : dayjs();
  if (!refDate.isValid()) return false;

  return refDate.diff(dobDate, 'years') < 18;
};
